export class DataCentralService{constructor(api){this.api=void 0;this.api=api;}async executeQuery(sql){return this.api.post('/api/data-central/query',{sql});}async getArrExecutiveSummary(){let months=arguments.length>0&&arguments[0]!==undefined?arguments[0]:12;const sql=`
      SELECT * FROM \`phydatacentral.vw_arr_executive_summary\`
      WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      ORDER BY month_date DESC
      LIMIT ${months}
    `;return this.executeQuery(sql);}async getPortfolioMetrics(){let months=arguments.length>0&&arguments[0]!==undefined?arguments[0]:12;const sql=`
      SELECT * FROM \`phydatacentral.vw_portfolio_metrics\`
      WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      ORDER BY month_date DESC
      LIMIT ${months}
    `;return this.executeQuery(sql);}async getTopGrowingTenants(){let limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;const sql=`
      SELECT tenantId, tenant_name, monthly_amount_eur, monthly_amount_original,
             original_currency, mom_growth_rate, country, parent_tenant_id, parent_tenant_name
      FROM \`phydatacentral.vw_tenant_growth_metrics\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_tenant_growth_metrics\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND mom_growth_rate IS NOT NULL
      ORDER BY mom_growth_rate DESC
      LIMIT ${limit}
    `;return this.executeQuery(sql);}async getTopDecliningTenants(){let limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;const sql=`
      SELECT tenantId, tenant_name, monthly_amount_eur, monthly_amount_original,
             original_currency, mom_growth_rate, country
      FROM \`phydatacentral.vw_tenant_growth_metrics\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_tenant_growth_metrics\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND mom_growth_rate IS NOT NULL
      ORDER BY mom_growth_rate ASC
      LIMIT ${limit}
    `;return this.executeQuery(sql);}async getCurrentMonthActiveTenants(){const sql=`
      SELECT total_active_tenants
      FROM \`phydatacentral.vw_arr_executive_summary\`
      WHERE month_date = DATE_TRUNC(CURRENT_DATE(), MONTH)
      ORDER BY month_date DESC
      LIMIT 1
    `;return this.executeQuery(sql);}async getPreviousMonthConsumption(){const sql=`
      SELECT COALESCE(SUM(monthly_amount_eur), 0) as monthly_consumption_eur
      FROM \`phydatacentral.vw_arr_monthly_analysis\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
    `;return this.executeQuery(sql);}async getCurrentConsumption(){const sql=`
      SELECT COALESCE(consumption_based_arr_eur, 0) as consumption_based_arr_eur
      FROM \`phydatacentral.vw_arr_executive_summary\`
      WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      ORDER BY month_date DESC
      LIMIT 1
    `;return this.executeQuery(sql);}async getCurrentMonthConsumption(){const sql=`
      SELECT SUM(monthly_amount_eur) as monthly_consumption_eur
      FROM \`phydatacentral.vw_arr_monthly_analysis\`
      WHERE month_date = DATE_TRUNC(CURRENT_DATE(), MONTH)
    `;return this.executeQuery(sql);}async getArrBreakdownByMonth(){let months=arguments.length>0&&arguments[0]!==undefined?arguments[0]:12;const sql=`
      SELECT
        month_date,
        -- Committed ARR: For tenants where commitment > consumption (CORRECTED to match chart)
        SUM(CASE
          WHEN is_agreement_active = true AND annual_commit_amount_eur > 0 AND annual_commit_amount_eur > annualized_consumption_eur
          THEN annual_commit_amount_eur
          ELSE 0
        END) as committed_arr_eur,

        -- Overage ARR: For tenants where consumption > commitment (the excess part)
        SUM(CASE
          WHEN is_agreement_active = true AND annual_commit_amount_eur > 0 AND annualized_consumption_eur > annual_commit_amount_eur
          THEN annualized_consumption_eur - annual_commit_amount_eur
          ELSE 0
        END) as overage_arr_eur,

        -- Pure consumption ARR: Tenants without agreements + base consumption for exceeding tenants
        SUM(CASE
          WHEN is_agreement_active = false OR annual_commit_amount_eur = 0
          THEN annualized_consumption_eur
          WHEN is_agreement_active = true AND annual_commit_amount_eur > 0 AND annualized_consumption_eur > annual_commit_amount_eur
          THEN annual_commit_amount_eur
          ELSE 0
        END) as pure_consumption_arr_eur

      FROM \`phydatacentral.vw_arr_monthly_analysis\`
      WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      GROUP BY month_date
      ORDER BY month_date DESC
      LIMIT ${months}
    `;return this.executeQuery(sql);}async getTenantBreakdowns(){const sql=`
      SELECT
        COUNT(CASE WHEN t.isPartnerOrganization = true THEN 1 END) as partner_customers,
        COUNT(CASE WHEN t.isPartnerOrganization = false OR t.isPartnerOrganization IS NULL THEN 1 END) as direct_customers,
        COUNT(CASE WHEN t.parentOrganizationId IS NULL THEN 1 END) as direct_billing_customers,
        COUNT(CASE WHEN t.parentOrganizationId IS NOT NULL THEN 1 END) as parent_billing_customers,
        -- Use actual subscription sources for billing type counts
        COUNT(CASE WHEN s.source = 'stripe' THEN 1 END) as stripe_billing_customers,
        COUNT(CASE WHEN s.source = 'direct-invoice' THEN 1 END) as direct_invoice_customers,
        COUNT(CASE WHEN s.source = 'partner-invoice' THEN 1 END) as partner_invoice_customers,
        COUNT(CASE WHEN s.source = 'azure-saas' THEN 1 END) as azure_billing_customers,
        COUNT(CASE WHEN s.organizationId IS NULL THEN 1 END) as no_subscription_customers,
        COUNT(*) as total_tenants
      FROM \`phydatacentral.tenant\` t
      LEFT JOIN \`phydatacentral.subscription\` s ON t.id = s.organizationId AND s.status = 'subscribed'
      WHERE t.id IN (
        SELECT DISTINCT tenantId
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date = (
          SELECT MAX(month_date)
          FROM \`phydatacentral.vw_arr_monthly_analysis\`
          WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
        )
      )
    `;return this.executeQuery(sql);}// Billing Discrepancy Methods
async getExpiredActiveAgreements(){const sql=`
      SELECT
        ea.id,
        ea.organizationId,
        ea.name,
        ea.endDate,
        ea.startDate,
        ea.status,
        ea.committedConsumption_value / 100000.0 as committed_amount,
        ea.committedConsumption_currency,
        t.organizationName as tenant_name,
        t.parentOrganizationId,
        -- Calculate ARR based on agreement duration (in original currency)
        CASE
          WHEN ea.startDate IS NOT NULL AND ea.endDate IS NOT NULL
          THEN (ea.committedConsumption_value / 100000.0) /
               GREATEST(1, DATE_DIFF(PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)),
                                    PARSE_DATE('%Y-%m-%d', SUBSTR(ea.startDate, 1, 10)), DAY) / 365.25)
          ELSE ea.committedConsumption_value / 100000.0
        END as arr_value,
        -- Calculate ARR in EUR using exchange rates
        CASE
          WHEN ea.startDate IS NOT NULL AND ea.endDate IS NOT NULL
          THEN
            CASE
              WHEN ea.committedConsumption_currency = 'EUR'
              THEN (ea.committedConsumption_value / 100000.0) / GREATEST(1, DATE_DIFF(PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)), PARSE_DATE('%Y-%m-%d', SUBSTR(ea.startDate, 1, 10)), DAY) / 365.25)
              ELSE ((ea.committedConsumption_value / 100000.0) / GREATEST(1, DATE_DIFF(PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)), PARSE_DATE('%Y-%m-%d', SUBSTR(ea.startDate, 1, 10)), DAY) / 365.25)) / COALESCE(er.rate, 1.0)
            END
          ELSE
            CASE
              WHEN ea.committedConsumption_currency = 'EUR'
              THEN ea.committedConsumption_value / 100000.0
              ELSE (ea.committedConsumption_value / 100000.0) / COALESCE(er.rate, 1.0)
            END
        END as arr_value_eur,
        -- Get yearly consumption from monthly analysis
        COALESCE(ma.monthly_amount_eur * 12, 0) as yearly_consumption_eur,
        -- Check if agreement has missing transactions (no recent activity)
        CASE
          WHEN ma.tenantId IS NULL THEN true
          ELSE false
        END as has_missing_transactions,
        -- Calculate agreement length in months
        CASE
          WHEN ea.startDate IS NOT NULL AND ea.endDate IS NOT NULL
          THEN DATE_DIFF(PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)),
                        PARSE_DATE('%Y-%m-%d', SUBSTR(ea.startDate, 1, 10)), MONTH)
          ELSE NULL
        END as agreement_length_months,
        -- Calculate lost revenue (ARR EUR - Yearly Consumption EUR)
        (
          CASE
            WHEN ea.startDate IS NOT NULL AND ea.endDate IS NOT NULL
            THEN
              CASE
                WHEN ea.committedConsumption_currency = 'EUR'
                THEN (ea.committedConsumption_value / 100000.0) / GREATEST(1, DATE_DIFF(PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)), PARSE_DATE('%Y-%m-%d', SUBSTR(ea.startDate, 1, 10)), DAY) / 365.25)
                ELSE ((ea.committedConsumption_value / 100000.0) / GREATEST(1, DATE_DIFF(PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)), PARSE_DATE('%Y-%m-%d', SUBSTR(ea.startDate, 1, 10)), DAY) / 365.25)) / COALESCE(er.rate, 1.0)
              END
            ELSE
              CASE
                WHEN ea.committedConsumption_currency = 'EUR'
                THEN ea.committedConsumption_value / 100000.0
                ELSE (ea.committedConsumption_value / 100000.0) / COALESCE(er.rate, 1.0)
              END
          END
        ) - COALESCE(ma.monthly_amount_eur * 12, 0) as lost_revenue_eur
      FROM \`phydatacentral.enterpriseAgreement\` ea
      LEFT JOIN \`phydatacentral.tenant\` t ON ea.organizationId = t.id
      LEFT JOIN (
        SELECT tenantId, monthly_amount_eur
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date = (
          SELECT MAX(month_date)
          FROM \`phydatacentral.vw_arr_monthly_analysis\`
          WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
        )
      ) ma ON ea.organizationId = ma.tenantId
      LEFT JOIN (
        SELECT currency, rate
        FROM \`phydatacentral.exchange_rates\`
        WHERE base_currency = 'EUR'
        AND date = (SELECT MAX(date) FROM \`phydatacentral.exchange_rates\`)
      ) er ON er.currency = ea.committedConsumption_currency
      WHERE ea.status = 'active'
      AND ea.endDate IS NOT NULL
      AND PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)) < CURRENT_DATE()
      AND ea.organizationId != '5cbac8a388e174147b878cdd'
      AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '')
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      -- Exclude expired agreements if tenant has a newer non-expired active agreement
      AND ea.organizationId NOT IN (
        SELECT DISTINCT organizationId
        FROM \`phydatacentral.enterpriseAgreement\` newer_ea
        WHERE newer_ea.status = 'active'
        AND newer_ea.endDate IS NOT NULL
        AND PARSE_DATE('%Y-%m-%d', SUBSTR(newer_ea.endDate, 1, 10)) >= CURRENT_DATE()
        AND newer_ea.organizationId = ea.organizationId
      )
      ORDER BY ea.endDate DESC
    `;return this.executeQuery(sql);}async getDuplicateAgreements(){const sql=`
      SELECT
        ea.organizationId,
        t.organizationName as tenant_name,
        ea.id as agreement_id,
        ea.name as agreement_name,
        ea.startDate,
        ea.endDate,
        ea.committedConsumption_value / 100000.0 as committed_amount,
        ea.committedConsumption_currency,
        CASE
          WHEN ea.committedConsumption_currency = 'EUR'
          THEN ea.committedConsumption_value / 100000.0
          ELSE (ea.committedConsumption_value / 100000.0) / COALESCE(er.rate, 1.0)
        END as committed_amount_eur,
        COUNT(*) OVER (PARTITION BY ea.organizationId) as agreement_count
      FROM \`phydatacentral.enterpriseAgreement\` ea
      LEFT JOIN \`phydatacentral.tenant\` t ON ea.organizationId = t.id
      LEFT JOIN (
        SELECT currency, rate
        FROM \`phydatacentral.exchange_rates\`
        WHERE base_currency = 'EUR'
        AND date = (SELECT MAX(date) FROM \`phydatacentral.exchange_rates\`)
      ) er ON er.currency = ea.committedConsumption_currency
      WHERE ea.status = 'active'
      AND ea.committedConsumption_value > 0
      AND ea.organizationId != '5cbac8a388e174147b878cdd'
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      AND ea.organizationId IN (
        SELECT organizationId
        FROM \`phydatacentral.enterpriseAgreement\`
        WHERE status = 'active' AND committedConsumption_value > 0
        GROUP BY organizationId
        HAVING COUNT(*) > 1
      )
      ORDER BY committed_amount_eur DESC
    `;return this.executeQuery(sql);}async getAgreementsWithoutTransactions(){const sql=`
      SELECT
        ea.id,
        ea.organizationId,
        ea.name,
        ea.committedConsumption_value / 100000.0 as committed_amount,
        ea.committedConsumption_currency,
        t.organizationName as tenant_name,
        ea.status
      FROM \`phydatacentral.enterpriseAgreement\` ea
      LEFT JOIN \`phydatacentral.tenant\` t ON ea.organizationId = t.id
      WHERE ea.status = 'active'
      AND ea.committedConsumption_value > 0
      AND ea.organizationId != '5cbac8a388e174147b878cdd'
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      AND ea.organizationId NOT IN (
        SELECT DISTINCT tenantId
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date >= DATE_SUB(CURRENT_DATE(), INTERVAL 2 MONTH)
      )
      ORDER BY ea.committedConsumption_value DESC
    `;return this.executeQuery(sql);}async getActiveUsageExpiredAgreements(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        ea.name as agreement_name,
        ea.endDate,
        ea.committedConsumption_value / 100000.0 as expired_committed_amount,
        t.parentOrganizationId
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      JOIN \`phydatacentral.enterpriseAgreement\` ea ON ma.tenantId = ea.organizationId
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      WHERE ma.month_date >= DATE_SUB(CURRENT_DATE(), INTERVAL 1 MONTH)
      AND ma.monthly_amount_eur > 0
      AND ea.status = 'active'
      AND ea.endDate IS NOT NULL
      AND PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)) < CURRENT_DATE()
      AND ma.tenantId != '5cbac8a388e174147b878cdd'
      AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '')
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getTenantsWithoutSubscriptions(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.parentOrganizationId
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      WHERE ma.month_date >= DATE_SUB(CURRENT_DATE(), INTERVAL 1 MONTH)
      AND ma.monthly_amount_eur > 100  -- Only significant revenue
      AND ma.tenantId != '5cbac8a388e174147b878cdd'
      AND ma.tenantId NOT IN (
        SELECT DISTINCT organizationId
        FROM \`phydatacentral.subscription\`
        WHERE organizationId IS NOT NULL
      )
      AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '')
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getDiscrepancySummary(){const sql=`
      SELECT
        COUNT(CASE WHEN ea.status = 'active' AND ea.endDate IS NOT NULL AND PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)) < CURRENT_DATE() AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '') AND (t.isDeleted IS NULL OR t.isDeleted = false)
          AND ea.organizationId NOT IN (
            SELECT DISTINCT organizationId
            FROM \`phydatacentral.enterpriseAgreement\` newer_ea
            WHERE newer_ea.status = 'active'
            AND newer_ea.endDate IS NOT NULL
            AND PARSE_DATE('%Y-%m-%d', SUBSTR(newer_ea.endDate, 1, 10)) >= CURRENT_DATE()
            AND newer_ea.organizationId = ea.organizationId
          ) THEN 1 END) as expired_active_agreements,
        SUM(CASE WHEN ea.status = 'active' AND ea.endDate IS NOT NULL AND PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)) < CURRENT_DATE() AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '') AND (t.isDeleted IS NULL OR t.isDeleted = false)
          AND ea.organizationId NOT IN (
            SELECT DISTINCT organizationId
            FROM \`phydatacentral.enterpriseAgreement\` newer_ea
            WHERE newer_ea.status = 'active'
            AND newer_ea.endDate IS NOT NULL
            AND PARSE_DATE('%Y-%m-%d', SUBSTR(newer_ea.endDate, 1, 10)) >= CURRENT_DATE()
            AND newer_ea.organizationId = ea.organizationId
          )
            THEN
              CASE
                WHEN ea.committedConsumption_currency = 'EUR' THEN ea.committedConsumption_value / 100000.0
                ELSE (ea.committedConsumption_value / 100000.0) / COALESCE(er.rate, 1.0)
              END
            ELSE 0 END) as expired_committed_value,
        SUM(CASE WHEN ea.status = 'active' AND ea.endDate IS NOT NULL AND PARSE_DATE('%Y-%m-%d', SUBSTR(ea.endDate, 1, 10)) < CURRENT_DATE() AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '') AND (t.isDeleted IS NULL OR t.isDeleted = false)
          AND ea.organizationId NOT IN (
            SELECT DISTINCT organizationId
            FROM \`phydatacentral.enterpriseAgreement\` newer_ea
            WHERE newer_ea.status = 'active'
            AND newer_ea.endDate IS NOT NULL
            AND PARSE_DATE('%Y-%m-%d', SUBSTR(newer_ea.endDate, 1, 10)) >= CURRENT_DATE()
            AND newer_ea.organizationId = ea.organizationId
          )
            THEN
              CASE
                WHEN ea.committedConsumption_currency = 'EUR' THEN ea.committedConsumption_value / 100000.0
                ELSE (ea.committedConsumption_value / 100000.0) / COALESCE(er.rate, 1.0)
              END
            ELSE 0 END) as total_revenue_at_risk
      FROM \`phydatacentral.enterpriseAgreement\` ea
      LEFT JOIN \`phydatacentral.tenant\` t ON ea.organizationId = t.id
      LEFT JOIN (
        SELECT currency, rate
        FROM \`phydatacentral.exchange_rates\`
        WHERE base_currency = 'EUR'
        AND date = (SELECT MAX(date) FROM \`phydatacentral.exchange_rates\`)
      ) er ON er.currency = ea.committedConsumption_currency
      WHERE ea.organizationId != '5cbac8a388e174147b878cdd'
    `;return this.executeQuery(sql);}async getTenantsWithNoBillingMethod(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.parentOrganizationId
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date >= DATE_SUB(CURRENT_DATE(), INTERVAL 1 MONTH)
      AND ma.monthly_amount_eur > 50  -- Tenants with some revenue
      AND ma.tenantId != '5cbac8a388e174147b878cdd'
      AND (t.parentOrganizationId IS NULL OR t.parentOrganizationId = '')
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      AND s.organizationId IS NOT NULL  -- Has subscription
      AND (s.data_stripeCustomerId IS NULL OR s.data_stripeCustomerId = '')  -- No Stripe billing
      AND s.source != 'azure-saas'  -- Not Azure billing
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getPartnerTenantsWithWrongBillingMethod(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.parentOrganizationId,
        s.source as subscription_billing_method
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date >= DATE_SUB(CURRENT_DATE(), INTERVAL 1 MONTH)
      AND ma.monthly_amount_eur > 50  -- Tenants with some revenue
      AND ma.tenantId != '5cbac8a388e174147b878cdd'
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      AND t.parentOrganizationId IS NOT NULL  -- Has parent (is partner tenant)
      AND t.parentOrganizationId != ''
      AND s.organizationId IS NOT NULL  -- Has subscription
      AND s.source != 'partner-invoice'  -- Billing method is NOT partner-invoice
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}// New tenant configuration discrepancy queries
async getPartnerOrgsWithoutDirectInvoice(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        COALESCE(s.source, 'No Subscription') as current_billing_method
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND t.isPartnerOrganization = true
      AND (s.source != 'direct-invoice' OR s.source IS NULL)
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getTenantsWithParentButWrongBilling(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.parentOrganizationId,
        COALESCE(s.source, 'No Subscription') as current_billing_method
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND t.parentOrganizationId IS NOT NULL
      AND t.parentOrganizationId != ''
      AND (s.source != 'partner-invoice' OR s.source IS NULL)
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getTenantsWithNoSubscription(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.isPartnerOrganization,
        t.parentOrganizationId
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND s.organizationId IS NULL
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getMultiLevelPartnerHierarchy(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.parentOrganizationId,
        parent.organizationName as parent_name,
        parent.isPartnerOrganization as parent_is_partner,
        COALESCE(s.source, 'No Subscription') as current_billing_method
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.tenant\` parent ON t.parentOrganizationId = parent.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND t.isPartnerOrganization = true  -- Is a partner organization
      AND t.parentOrganizationId IS NOT NULL  -- But also has a parent
      AND t.parentOrganizationId != ''
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getGrandchildrenLostRevenue(){const sql=`
      SELECT
        ma.tenantId,
        ma.tenant_name,
        ma.monthly_amount_eur,
        ma.annualized_consumption_eur,
        t.parentOrganizationId,
        parent.organizationName as parent_name,
        parent.parentOrganizationId as grandparent_id,
        grandparent.organizationName as grandparent_name,
        COALESCE(s.source, 'No Subscription') as current_billing_method
      FROM \`phydatacentral.vw_arr_monthly_analysis\` ma
      LEFT JOIN \`phydatacentral.tenant\` t ON ma.tenantId = t.id
      LEFT JOIN \`phydatacentral.tenant\` parent ON t.parentOrganizationId = parent.id
      LEFT JOIN \`phydatacentral.tenant\` grandparent ON parent.parentOrganizationId = grandparent.id
      LEFT JOIN \`phydatacentral.subscription\` s ON ma.tenantId = s.organizationId AND s.status = 'subscribed'
      WHERE ma.month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND t.parentOrganizationId IS NOT NULL  -- Has parent
      AND t.parentOrganizationId != ''
      AND parent.parentOrganizationId IS NOT NULL  -- Parent also has parent (grandparent exists)
      AND parent.parentOrganizationId != ''
      AND (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY ma.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}// Demo Tenants Monitoring (Ombori Grid + Children) - Query base tables directly
async getDemoTenantConsumption(){const sql=`
      SELECT
        t.id as tenantId,
        t.organizationName as tenant_name,
        t.parentOrganizationId,
        CASE
          WHEN t.id = '5cbac8a388e174147b878cdd' THEN 'Demo Root'
          WHEN t.parentOrganizationId = '5cbac8a388e174147b878cdd' THEN 'Demo Child'
          ELSE 'Demo Descendant'
        END as tenant_type,
        -- Get monthly consumption from transactions for last complete month
        COALESCE(monthly_stats.monthly_revenue_eur, 0) as monthly_amount_eur,
        COALESCE(monthly_stats.monthly_revenue_eur * 12, 0) as annualized_consumption_eur
      FROM \`phydatacentral.tenant\` t
      LEFT JOIN (
        SELECT
          tenantId,
          SUM(value / 100000.0) as monthly_revenue_eur
        FROM \`phydatacentral.transaction\`
        WHERE DATE(transactionDate) >= DATE_SUB(DATE_TRUNC(CURRENT_DATE(), MONTH), INTERVAL 1 MONTH)
        AND DATE(transactionDate) < DATE_TRUNC(CURRENT_DATE(), MONTH)
        AND value > 0
        AND account = 'nonOrganisationAccount'
        GROUP BY tenantId
      ) monthly_stats ON t.id = monthly_stats.tenantId
      WHERE (
        t.id = '5cbac8a388e174147b878cdd'  -- Ombori Grid itself
        OR t.parentOrganizationId = '5cbac8a388e174147b878cdd'  -- Direct children
        OR t.parentOrganizationId IN (  -- Grandchildren
          SELECT id FROM \`phydatacentral.tenant\`
          WHERE parentOrganizationId = '5cbac8a388e174147b878cdd'
        )
      )
      ORDER BY
        CASE
          WHEN t.id = '5cbac8a388e174147b878cdd' THEN 0
          WHEN t.parentOrganizationId = '5cbac8a388e174147b878cdd' THEN 1
          ELSE 2
        END,
        monthly_stats.monthly_revenue_eur DESC
    `;return this.executeQuery(sql);}async getDemoTenantSummary(){const sql=`
      SELECT
        COUNT(DISTINCT t.id) as total_demo_tenants,
        COUNT(CASE WHEN t.id = '5cbac8a388e174147b878cdd' THEN 1 END) as root_tenant,
        COUNT(CASE WHEN t.parentOrganizationId = '5cbac8a388e174147b878cdd' THEN 1 END) as direct_children,
        COUNT(CASE WHEN t.parentOrganizationId IN (
          SELECT id FROM \`phydatacentral.tenant\`
          WHERE parentOrganizationId = '5cbac8a388e174147b878cdd'
        ) THEN 1 END) as grandchildren,
        COALESCE(SUM(monthly_stats.monthly_revenue_eur), 0) as total_monthly_consumption_eur,
        COALESCE(SUM(monthly_stats.monthly_revenue_eur * 12), 0) as total_annual_consumption_eur
      FROM \`phydatacentral.tenant\` t
      LEFT JOIN (
        SELECT
          tenantId,
          SUM(value / 100000.0) as monthly_revenue_eur
        FROM \`phydatacentral.transaction\`
        WHERE DATE(transactionDate) >= DATE_SUB(DATE_TRUNC(CURRENT_DATE(), MONTH), INTERVAL 1 MONTH)
        AND DATE(transactionDate) < DATE_TRUNC(CURRENT_DATE(), MONTH)
        AND value > 0
        AND account = 'nonOrganisationAccount'
        GROUP BY tenantId
      ) monthly_stats ON t.id = monthly_stats.tenantId
      WHERE (
        t.id = '5cbac8a388e174147b878cdd'
        OR t.parentOrganizationId = '5cbac8a388e174147b878cdd'
        OR t.parentOrganizationId IN (
          SELECT id FROM \`phydatacentral.tenant\`
          WHERE parentOrganizationId = '5cbac8a388e174147b878cdd'
        )
      )
    `;return this.executeQuery(sql);}async getLastMonthConsumptionByTenants(tenantIds){if(!tenantIds.length){return{success:true,data:[],rowCount:0,executedAt:new Date().toISOString()};}const tenantIdList=tenantIds.map(id=>`'${id}'`).join(', ');const sql=`
      SELECT
        tenantId,
        monthly_amount_eur,
        monthly_amount_original,
        original_currency
      FROM \`phydatacentral.vw_tenant_monthly_consumption\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_tenant_monthly_consumption\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND tenantId IN (${tenantIdList})
      ORDER BY monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getChildTenantConsumption(parentTenantIds){if(!parentTenantIds.length){return{success:true,data:[],rowCount:0,executedAt:new Date().toISOString()};}const tenantIdList=parentTenantIds.map(id=>`'${id}'`).join(', ');const sql=`
      SELECT
        t.parentOrganizationId as parentTenantId,
        tc.tenantId as childTenantId,
        tc.monthly_amount_eur
      FROM \`phydatacentral.tenant\` t
      JOIN \`phydatacentral.vw_tenant_monthly_consumption\` tc ON t.id = tc.tenantId
      WHERE t.parentOrganizationId IN (${tenantIdList})
      AND tc.month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_tenant_monthly_consumption\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      ORDER BY tc.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getTenantsConsumptionAndArrData(){const sql=`
      SELECT
        tenantId,
        tenant_name,
        monthly_amount_eur,
        monthly_amount_original,
        arr_eur,
        original_currency,
        mom_growth_percentage,
        mom_growth_eur
      FROM \`phydatacentral.vw_arr_monthly_analysis\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      ORDER BY arr_eur DESC
    `;return this.executeQuery(sql);}async getTenantsInfrastructureData(){// Use separate simpler queries and combine on frontend
// This is a simplified approach due to CTE restrictions
const sql=`
      SELECT
        t.id as tenantId,
        0 as installations_count,
        0 as devices_count,
        0 as users_count,
        0 as spaces_count
      FROM \`phydatacentral.tenant\` t
      WHERE (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY t.organizationName
    `;return this.executeQuery(sql);}async getEnterpriseAgreementData(){const sql=`
      SELECT
        ea.organizationId as tenantId,
        JSON_EXTRACT_SCALAR(ea.organizationConfiguration, '$.tenantName') as tenant_name,
        ea.startDate as agreement_start_date,
        ea.endDate as agreement_end_date,
        ea.committedConsumption_value as commit_value,
        ea.committedConsumption_currency as commit_currency,
        -- Convert commit value to EUR using latest exchange rates
        CASE
          WHEN ea.committedConsumption_currency = 'EUR' OR ea.committedConsumption_currency IS NULL
          THEN ea.committedConsumption_value
          ELSE ea.committedConsumption_value / COALESCE(er.rate, 1.0)
        END as commit_value_eur,
        ea.extraCredits_value as extra_credits_value,
        ea.extraCredits_currency as extra_credits_currency,
        ea.status as agreement_status,
        ea.name as agreement_name
      FROM \`phydatacentral.enterpriseAgreement\` ea
      LEFT JOIN (
        SELECT currency, rate
        FROM \`phydatacentral.exchange_rates\`
        WHERE base_currency = 'EUR'
        AND date = (SELECT MAX(date) FROM \`phydatacentral.exchange_rates\`)
      ) er ON er.currency = ea.committedConsumption_currency
      WHERE ea.status = 'active'
        AND (ea.isDeleted IS NULL OR ea.isDeleted = false)
      ORDER BY JSON_EXTRACT_SCALAR(ea.organizationConfiguration, '$.tenantName')
    `;return this.executeQuery(sql);}async getLatestExchangeRates(){const sql=`
      SELECT
        currency,
        rate,
        base_currency,
        date
      FROM \`phydatacentral.exchange_rates\`
      WHERE base_currency = 'EUR'
        AND date = (SELECT MAX(date) FROM \`phydatacentral.exchange_rates\`)
      ORDER BY currency
    `;return this.executeQuery(sql);}async getTenantsPaymentMethods(){const sql=`
      SELECT
        t.id as tenantId,
        t.organizationName as tenant_name,
        s.source as payment_method,
        s.status as subscription_status
      FROM \`phydatacentral.tenant\` t
      LEFT JOIN \`phydatacentral.subscription\` s ON t.id = s.organizationId AND s.status = 'subscribed'
      WHERE (t.isDeleted IS NULL OR t.isDeleted = false)
      ORDER BY t.organizationName
    `;return this.executeQuery(sql);}async getPrecedingMonthConsumption(){const sql=`
      SELECT
        tenantId,
        tenant_name,
        monthly_amount_eur as preceding_month_amount_eur,
        monthly_amount_original as preceding_month_amount_original,
        original_currency
      FROM \`phydatacentral.vw_arr_monthly_analysis\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_SUB(DATE_TRUNC(CURRENT_DATE(), MONTH), INTERVAL 1 MONTH)
      )
      ORDER BY preceding_month_amount_eur DESC
    `;return this.executeQuery(sql);}// Get SKU performance with original currency breakdown, excluding demo tenants
async getSkuPerformanceWithCurrency(){const sql=`
      WITH demo_tenants AS (
        SELECT DISTINCT t.id as demo_tenant_id
        FROM \`phydatacentral.tenant\` t
        WHERE (
          t.id = '5cbac8a388e174147b878cdd'  -- Ombori Grid root
          OR t.parentOrganizationId = '5cbac8a388e174147b878cdd'  -- Direct children
        )
      ),
      latest_exchange_rates AS (
        SELECT 
          target_currency, 
          FIRST_VALUE(rate) OVER (
            PARTITION BY target_currency 
            ORDER BY date DESC
          ) as rate
        FROM \`phydatacentral.vw_exchange_rates\`
        QUALIFY ROW_NUMBER() OVER (PARTITION BY target_currency ORDER BY date DESC) = 1
      ),
      sku_currency_breakdown AS (
        SELECT
          source_metadata_sku as sku,
          currency,
          SUM(value / 100000.0) as monthly_amount_original,
          SUM(CASE
            WHEN currency = 'EUR' THEN value / 100000.0
            WHEN er.rate IS NOT NULL THEN value / 100000.0 / er.rate
            ELSE 0  -- Exclude transactions with missing exchange rates
          END) as monthly_amount_eur,
          COUNT(DISTINCT tenantId) as tenant_count
        FROM \`phydatacentral.transaction\` t
        LEFT JOIN latest_exchange_rates er ON t.currency = er.target_currency
        WHERE DATE(transactionDate) >= DATE_SUB(DATE_TRUNC(CURRENT_DATE(), MONTH), INTERVAL 1 MONTH)
          AND DATE(transactionDate) < DATE_TRUNC(CURRENT_DATE(), MONTH)
          AND value > 0
          AND account = 'nonOrganisationAccount'
          AND source_metadata_sku IS NOT NULL
          AND source_metadata_sku != ''
          -- Exclude demo tenants
          AND tenantId NOT IN (SELECT demo_tenant_id FROM demo_tenants)
        GROUP BY source_metadata_sku, currency
      ),
      sku_names AS (
        SELECT DISTINCT
          sku,
          FIRST_VALUE(sku_name) OVER (PARTITION BY sku ORDER BY monthly_amount_eur DESC) as sku_name
        FROM \`phydatacentral.vw_sku_performance\`
        WHERE month_date = (
          SELECT MAX(month_date)
          FROM \`phydatacentral.vw_sku_performance\`
          WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
        )
      )
      SELECT
        s.sku,
        COALESCE(n.sku_name, s.sku) as sku_name,
        s.currency,
        s.monthly_amount_original,
        s.monthly_amount_eur,
        s.tenant_count
      FROM sku_currency_breakdown s
      LEFT JOIN sku_names n ON s.sku = n.sku
      WHERE s.monthly_amount_eur > 0
      ORDER BY s.sku, s.monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getActiveTenantsAverageRevenue(){const sql=`
      SELECT
        COUNT(*) as active_tenants_with_consumption,
        AVG(arr_eur) as avg_arr_per_active_tenant_eur,
        SUM(arr_eur) as total_arr_eur
      FROM \`phydatacentral.vw_arr_monthly_analysis\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_arr_monthly_analysis\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      AND monthly_amount_eur > 0  -- Only include tenants with actual consumption
    `;return this.executeQuery(sql);}// SKU Performance and Revenue Optimization Methods
async getSkuPerformanceAnalysis(){const sql=`
      SELECT
        sku,
        COALESCE(sku_name, sku) as sku_name,
        COALESCE(revenueType, 'saasRevenue') as revenueType,
        monthly_amount_eur,
        tenant_count,
        transaction_count,
        avg_revenue_per_tenant_sku,
        mom_growth_rate,
        monthly_amount_eur * 12 as annualized_revenue_eur,
        CASE
          WHEN mom_growth_rate > 0.5 THEN 'High Growth (>50%)'
          WHEN mom_growth_rate > 0.1 THEN 'Moderate Growth (10-50%)'
          WHEN mom_growth_rate > 0.01 THEN 'Slow Growth (1-10%)'
          WHEN mom_growth_rate > -0.05 THEN 'Stable'
          ELSE 'Declining'
        END as growth_category,
        CASE
          WHEN tenant_count >= 20 AND avg_revenue_per_tenant_sku >= 500 THEN 'Enterprise Cornerstone'
          WHEN tenant_count >= 10 AND avg_revenue_per_tenant_sku >= 200 THEN 'Mid-Market Driver'
          WHEN tenant_count < 5 AND avg_revenue_per_tenant_sku >= 1000 THEN 'Premium Niche'
          WHEN tenant_count >= 15 AND avg_revenue_per_tenant_sku < 200 THEN 'High Volume Low Margin'
          ELSE 'Emerging/Experimental'
        END as revenue_segment,
        CASE
          WHEN ROW_NUMBER() OVER (ORDER BY monthly_amount_eur DESC) <= 5 AND mom_growth_rate < -0.1 THEN 'CRITICAL: Top SKU Declining'
          WHEN ROW_NUMBER() OVER (ORDER BY monthly_amount_eur DESC) <= 5 AND mom_growth_rate > 0.3 THEN 'DOUBLE DOWN: Top SKU Growing'
          WHEN ROW_NUMBER() OVER (ORDER BY monthly_amount_eur DESC) <= 10 THEN 'MONITOR CLOSELY'
          WHEN monthly_amount_eur < 50 THEN 'SUNSET CANDIDATE'
          ELSE 'STANDARD MONITORING'
        END as executive_priority
      FROM \`phydatacentral.vw_sku_performance\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_sku_performance\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
      ORDER BY monthly_amount_eur DESC
    `;return this.executeQuery(sql);}async getSkuPortfolioSummary(){const sql=`
      SELECT
        SUM(monthly_amount_eur) as total_monthly_revenue,
        SUM(monthly_amount_eur) * 12 as annualized_portfolio_value,
        COUNT(*) as total_active_skus,
        COUNT(CASE WHEN mom_growth_rate > 0.5 THEN 1 END) as high_growth_skus,
        COUNT(CASE WHEN mom_growth_rate < -0.1 THEN 1 END) as declining_skus,
        ROUND(SUM(CASE WHEN revenueType = 'saasRevenue' THEN monthly_amount_eur ELSE 0 END) / SUM(monthly_amount_eur) * 100, 1) as saas_revenue_percentage,
        ROUND(SUM(CASE WHEN revenueType = 'professionalServices' THEN monthly_amount_eur ELSE 0 END) / SUM(monthly_amount_eur) * 100, 1) as services_revenue_percentage,
        AVG(tenant_count) as avg_tenant_penetration,
        MAX(tenant_count) as max_tenant_penetration,
        AVG(avg_revenue_per_tenant_sku) as portfolio_avg_arpt
      FROM \`phydatacentral.vw_sku_performance\`
      WHERE month_date = (
        SELECT MAX(month_date)
        FROM \`phydatacentral.vw_sku_performance\`
        WHERE month_date < DATE_TRUNC(CURRENT_DATE(), MONTH)
      )
    `;return this.executeQuery(sql);}async getSkuTrendsAnalysis(){let months=arguments.length>0&&arguments[0]!==undefined?arguments[0]:6;const sql=`
      SELECT
        sku,
        sku_name,
        COUNT(*) as months_tracked,
        AVG(monthly_amount_eur) as avg_monthly_revenue,
        SUM(monthly_amount_eur) as total_revenue_period,
        AVG(tenant_count) as avg_tenant_count,
        MAX(tenant_count) as peak_tenant_count,
        AVG(mom_growth_rate) as avg_growth_rate,
        STDDEV(monthly_amount_eur) / AVG(monthly_amount_eur) as revenue_volatility,
        CASE
          WHEN AVG(monthly_amount_eur) > 2000 AND AVG(mom_growth_rate) > 0.1 THEN 'Star Performer'
          WHEN AVG(monthly_amount_eur) > 2000 AND AVG(mom_growth_rate) < -0.1 THEN 'Cash Cow at Risk'
          WHEN AVG(monthly_amount_eur) < 500 AND AVG(mom_growth_rate) > 0.5 THEN 'Rising Star'
          WHEN AVG(monthly_amount_eur) < 500 AND AVG(mom_growth_rate) < -0.2 THEN 'Sunset Candidate'
          ELSE 'Steady Performer'
        END as strategic_classification
      FROM \`phydatacentral.vw_sku_performance\`
      WHERE month_date >= DATE_SUB(
        (SELECT MAX(month_date) FROM \`phydatacentral.vw_sku_performance\`),
        INTERVAL ${months} MONTH
      )
      GROUP BY sku, sku_name
      HAVING COUNT(*) >= 3
      ORDER BY total_revenue_period DESC
    `;return this.executeQuery(sql);}// Pricing Discrepancy Analysis Methods
async getPricingDiscrepanciesAcrossCurrencies(){// Get raw SKU pricing data and process in JavaScript
const skuDataResponse=await this.getSkuPricingData();if(!skuDataResponse.success){return{success:false,data:[]};}// Get latest exchange rates from database
const exchangeRatesResponse=await this.getLatestExchangeRates();const exchangeRates={EUR:1.0};if(exchangeRatesResponse.success){exchangeRatesResponse.data.forEach(rate=>{exchangeRates[rate.target_currency]=rate.rate;});}const processedData=[];for(const sku of skuDataResponse.data){try{const priceInfo=JSON.parse(sku.priceInformation);// Find active pricing period (no endDate or current date within range)
const activePeriod=priceInfo.find(period=>{var _period$startDate,_period$startDate2,_period$startDate3;return!period.endDate||((_period$startDate=period.startDate)===null||_period$startDate===void 0?void 0:_period$startDate.includes('2023'))||((_period$startDate2=period.startDate)===null||_period$startDate2===void 0?void 0:_period$startDate2.includes('2024'))||((_period$startDate3=period.startDate)===null||_period$startDate3===void 0?void 0:_period$startDate3.includes('2025'));});if(!activePeriod||!activePeriod.prices){// Skip this SKU if no active period or prices
}else{// Calculate EUR monthly rates for each currency
const currencyRates=activePeriod.prices.map(price=>{const priceOriginal=price.value/100000.0;const priceEurDaily=priceOriginal/(exchangeRates[price.currency]||1);const priceEurMonthly=priceEurDaily*(sku.unit==='day'?30:1);return{currency:price.currency,priceOriginal,priceEurDaily,priceEurMonthly,currencySymbol:price.currency==='EUR'?'€':price.currency==='USD'?'$':price.currency==='SEK'?'kr':price.currency==='AED'?'د.إ':price.currency};}).filter(rate=>rate.priceOriginal>0);// Exclude zero prices
if(currencyRates.length>1){// Only process multi-currency SKUs
// Calculate variance and create breakdown
const eurMonthlyRates=currencyRates.map(r=>r.priceEurMonthly);const minRate=Math.min(...eurMonthlyRates);const maxRate=Math.max(...eurMonthlyRates);const avgRate=eurMonthlyRates.reduce((sum,rate)=>sum+rate,0)/eurMonthlyRates.length;const variance=minRate>0?maxRate/minRate:1;// Find EUR baseline for color coding
const eurRate=currencyRates.find(r=>r.currency==='EUR');const eurBaseline=eurRate?eurRate.priceEurMonthly:avgRate;// Create currency breakdown with proper formatting
const currencyBreakdown=currencyRates.sort((a,b)=>b.priceEurMonthly-a.priceEurMonthly).map(rate=>{const monthlyOriginal=rate.priceOriginal*(sku.unit==='day'?30:1);return`${rate.currency}: ${rate.currencySymbol}${rate.priceOriginal.toFixed(2)}/${sku.unit} (${rate.currencySymbol}${monthlyOriginal.toFixed(0)}/month) → €${rate.priceEurMonthly.toFixed(2)}/month`;}).join(' | ');// Severity classification
let severity='MINIMAL: <1.1x price difference';if(variance>2)severity='CRITICAL: >2x price difference';else if(variance>1.5)severity='HIGH: >1.5x price difference';else if(variance>1.2)severity='MEDIUM: >1.2x price difference';else if(variance>1.1)severity='LOW: >1.1x price difference';processedData.push({sku:sku.sku,sku_name:sku.sku_name,unit:sku.unit,currency_count:currencyRates.length,min_arpt_eur:minRate,max_arpt_eur:maxRate,avg_arpt_eur:avgRate,price_variance_ratio:variance,discrepancy_severity:severity,currency_breakdown:currencyBreakdown,eur_baseline:eurBaseline});}}}catch(error){console.error(`Error parsing pricing for SKU ${sku.sku}:`,error);}}return{success:true,data:processedData.sort((a,b)=>b.price_variance_ratio-a.price_variance_ratio),rowCount:processedData.length,executedAt:new Date().toISOString()};}async getSkuCurrencyPricingBreakdown(sku){// Get raw SKU pricing data for specific SKU and process in JavaScript
const skuDataResponse=await this.executeQuery(`
      SELECT
        sku,
        name as sku_name,
        unit,
        priceInformation
      FROM \`phydatacentral.sku\`
      WHERE sku = '${sku}'
        AND priceInformation IS NOT NULL
    `);if(!skuDataResponse.success||!skuDataResponse.data.length){return{success:false,data:[]};}const skuData=skuDataResponse.data[0];// Get latest exchange rates from database
const exchangeRatesResponse=await this.getLatestExchangeRates();const exchangeRates={EUR:1.0};if(exchangeRatesResponse.success){exchangeRatesResponse.data.forEach(rate=>{exchangeRates[rate.target_currency]=rate.rate;});}try{const priceInfo=JSON.parse(skuData.priceInformation);// Find active pricing period
const activePeriod=priceInfo.find(period=>{var _period$startDate4,_period$startDate5,_period$startDate6;return!period.endDate||((_period$startDate4=period.startDate)===null||_period$startDate4===void 0?void 0:_period$startDate4.includes('2023'))||((_period$startDate5=period.startDate)===null||_period$startDate5===void 0?void 0:_period$startDate5.includes('2024'))||((_period$startDate6=period.startDate)===null||_period$startDate6===void 0?void 0:_period$startDate6.includes('2025'));});if(!activePeriod||!activePeriod.prices){return{success:false,data:[]};}// Process each currency
const currencyData=activePeriod.prices.filter(price=>price.value>0).map(price=>{const priceOriginal=price.value/100000.0;const priceEurDaily=priceOriginal/(exchangeRates[price.currency]||1);const priceEurMonthly=priceEurDaily*(skuData.unit==='day'?30:1);return{sku:skuData.sku,sku_name:skuData.sku_name,unit:skuData.unit,original_currency:price.currency,arpt_original:priceOriginal,arpt_eur:priceEurDaily,normalized_monthly_eur:priceEurMonthly,tenant_count:0,// Will be filled from performance data if needed
exchange_rate:exchangeRates[price.currency]||1,price_discrepancy_flag:'Current pricing from SKU JSON'};}).sort((a,b)=>b.normalized_monthly_eur-a.normalized_monthly_eur);return{success:true,data:currencyData,rowCount:currencyData.length,executedAt:new Date().toISOString()};}catch(error){console.error(`Error parsing pricing for SKU ${sku}:`,error);return{success:false,data:[]};}}async getCurrencyTrendsVsEur(){let months=arguments.length>0&&arguments[0]!==undefined?arguments[0]:12;const sql=`
      SELECT
        FORMAT_DATE('%b %y', er.date) as month,
        er.date as month_date,
        er.currency,
        er.rate,
        -- Calculate percentage change from EUR baseline (EUR = 1.0)
        (er.rate - 1.0) * 100 as rate_change_vs_eur,
        -- Calculate month-over-month percentage change
        CASE
          WHEN LAG(er.rate) OVER (PARTITION BY er.currency ORDER BY er.date) IS NOT NULL
          THEN ((er.rate - LAG(er.rate) OVER (PARTITION BY er.currency ORDER BY er.date))
                / LAG(er.rate) OVER (PARTITION BY er.currency ORDER BY er.date)) * 100
          ELSE 0
        END as mom_change_percentage
      FROM \`phydatacentral.exchange_rates\` er
      WHERE er.base_currency = 'EUR'
        AND er.currency IN ('USD', 'SEK', 'AED')
        AND er.date >= DATE_SUB(CURRENT_DATE(), INTERVAL ${months} MONTH)
      ORDER BY er.date, er.currency
    `;return this.executeQuery(sql);}async getRevenueUpliftPotential(){// Get raw SKU pricing data and process in JavaScript
const skuDataResponse=await this.getSkuPricingData();if(!skuDataResponse.success){return{success:false,data:[]};}// Get latest exchange rates from database
const exchangeRatesResponse=await this.getLatestExchangeRates();const exchangeRates={EUR:1.0};if(exchangeRatesResponse.success){exchangeRatesResponse.data.forEach(rate=>{exchangeRates[rate.target_currency]=rate.rate;});}const processedData=[];// Filter for specific SKUs
const targetSkus=['SPA001','TEN005','GAC004'];const filteredSkus=skuDataResponse.data.filter(sku=>targetSkus.includes(sku.sku));for(const sku of filteredSkus){try{const pricePeriods=JSON.parse(sku.priceInformation);// Find current/active pricing (no end date or starts in 2023+)
const activePeriods=pricePeriods.filter(period=>{var _period$startDate7;return!period.endDate||((_period$startDate7=period.startDate)===null||_period$startDate7===void 0?void 0:_period$startDate7.startsWith('2023'));});if(activePeriods.length===0){// Skip SKUs with no active periods
}else{const currencyPrices=[];for(const period of activePeriods){if(period.prices){for(const price of period.prices){const originalPrice=price.value/100000.0;const exchangeRate=exchangeRates[price.currency]||1.0;const eurMonthlyRate=originalPrice/exchangeRate*30;currencyPrices.push({currency:price.currency,original_price:originalPrice,eur_monthly_rate:eurMonthlyRate});}}}if(currencyPrices.length>0){// Calculate highest EUR monthly rate
const highestEurMonthlyRate=Math.max(...currencyPrices.map(p=>p.eur_monthly_rate));// Create currency breakdown string
const currencyBreakdown=currencyPrices.sort((a,b)=>b.eur_monthly_rate-a.eur_monthly_rate).map(p=>`${p.currency}: €${p.eur_monthly_rate.toFixed(2)}/month`).join(' | ');// Hardcoded current revenue data (from existing component logic)
const currentRevenueData={SPA001:17556,TEN005:8273,GAC004:2371};const tenantCounts={SPA001:105,TEN005:36,GAC004:23};const currentMonthlyRevenue=currentRevenueData[sku.sku]||0;const totalTenants=tenantCounts[sku.sku]||0;const potentialMonthlyRevenue=totalTenants*highestEurMonthlyRate;const revenueUplift=potentialMonthlyRevenue-currentMonthlyRevenue;const annualUpliftPotential=revenueUplift*12;const upliftPercentage=currentMonthlyRevenue>0?revenueUplift/currentMonthlyRevenue*100:0;processedData.push({sku:sku.sku,sku_name:sku.sku_name,current_monthly_revenue_eur:currentMonthlyRevenue,highest_eur_monthly_rate:highestEurMonthlyRate,total_tenants_all_currencies:totalTenants,potential_monthly_revenue_eur:potentialMonthlyRevenue,revenue_uplift_eur:revenueUplift,annual_uplift_potential_eur:annualUpliftPotential,uplift_percentage:upliftPercentage,currency_breakdown:currencyBreakdown});}}}catch(error){console.error(`Error processing SKU ${sku.sku}:`,error);// Skip this SKU on error
}}return{success:true,data:processedData};}async getSkuPricingData(){const sql=`
      SELECT
        sku,
        name as sku_name,
        unit,
        priceInformation
      FROM \`phydatacentral.sku\`
      WHERE priceInformation IS NOT NULL
        AND priceInformation != '[]'
        AND LENGTH(priceInformation) > 10
      ORDER BY sku
    `;return this.executeQuery(sql);}// Get latest exchange rates
async getLatestExchangeRates(){const sql=`
      SELECT 
        base_currency,
        target_currency,
        rate,
        date
      FROM \`phydatacentral.vw_exchange_rates\`
      WHERE date = (
        SELECT MAX(date) 
        FROM \`phydatacentral.vw_exchange_rates\`
      )
      ORDER BY target_currency
    `;return this.executeQuery(sql);}}